/**
* Testimonials Slider JS
* -----------------------------------------------------------------------------
*
* All the JS for the Testimonials Slider component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// import ScrollMagic from 'ScrollMagic';
// import animationGSAP from 'animation.gsap';
// import addIndicators from 'debug.addIndicators';
// import TweenMax from 'TweenMax';
// import TimelineMax from 'TimelineMax';
( function( app ) {
  const COMPONENT = {

    className: 'testimonials-slider',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      $( '.testimonials-slider .testimonials .testimonials-group' ).each( function( key, val ) {
        let rtl = true;
        if ( key % 2 === 0 ) {
          rtl = false;
        }
        $( this ).slick( {
          dots: false,
          arrows: false,
          autoplay: true,
          centerMode: true,
          speed: 15000,
          autoplaySpeed: 0,
          rtl: rtl,
          cssEase: 'linear',
          slidesToShow: 4,
          centerPadding: '0',
          infinite: true,
          variableWidth: true,
          pauseOnHover: false,
          pauseOnFocus: false,
          pauseOnDotsHover: false,
        } );
      } );

      $( '.testimonials-slider .testimonials.is-mobile' ).each( function( key, val ) {
        $( this ).slick( {
          dots: true,
          arrows: false,
          autoplay: true,
          centerMode: false,
          autoplaySpeed: 8000,
          slidesToShow: 1,
          infinite: true,
          responsive: [
            {
              breakpoint: 1024,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 1,
              },
            },
            {
              breakpoint: 768,
              settings: {
                slidesToShow: 1,
              },
            },
          ],
        } );
      } );

      $( '.testimonial-popup-trigger' ).magnificPopup( {
        type: 'inline',
        preloader: false,
      } );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'testimonials-slider', COMPONENT );
} )( app );
